module.exports = __webpack_public_path__ + "static/media/icon-dashboard-calendar.0249be5b.svg";